export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_GDM_5.46c3f016.jpg";